import styled from "@emotion/styled";

export const Root = styled.div({
    height: 80,
});

export const Content = styled.div({
    height: 80,
    whiteSpace: "nowrap",
});

export const AlignSpacer = styled.span({
    height: 30,
    display: "inline-block",
});

export const AddButtonContainer = styled.span({
    display: "inline-block",
    verticalAlign: "baseline",
    lineHeight: "34px",
});

export const PagerContainer = styled.span({
    display: "inline-block",
    verticalAlign: "top",
    marginTop: 4,
    lineHeight: "18px",
});
